import { PageGroup } from '@sleepstation/components'
import { VLayout } from '@sleepstation/components-layouts'
import mapping from '@sleepstation/components-markdown-copy-mapping'
import { MarkdownRenderer } from '@sleepstation/components-markdown-renderer'
import { LAYOUT_SPACING } from '@sleepstation/const'
import PropTypes from 'prop-types'
import { always, dissoc, when } from 'ramda'
import React from 'react'
import styled from 'styled-components'
import { useSearchParams } from 'react-router-dom'
import QUERY_PARAMS from '../../../../const/queryParams'
import FooterNav from '../../../shared/FooterNav'
import ListCard from '../../../shared/ListCard'
import BreakoutModuleNarrow from '../../../shared/breakoutModules/BreakoutModuleNarrow'
import Social from './Social'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  spacing: LAYOUT_SPACING.LARGE,
  'data-cy': `feedback-video-testimonial-page-content`,
})``

const Footer = styled.div``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const FeedbackVideoTestimonialPage = ({ content }) => {
  const [searchParams] = useSearchParams()
  const showSecondaryNav =
    searchParams.get(QUERY_PARAMS.SHOW_SECONDARY_NAV) === `1`

  const footerNav = when(
    always(!showSecondaryNav),
    dissoc(`secondary`),
    content.footerNav
  )

  return (
    <BreakoutModuleNarrow
      hasGradient={false}
      hasBottomBorder={false}
      paddingV={[1, 2, [2.25, 3]]}
    >
      <Layout>
        <PageGroup title={content.title} isClose bodySpacing={1.5}>
          <MarkdownRenderer htmlAst={content.bodyAst} mapping={mapping} />
          <ListCard {...content.tipsCard} />
          <ListCard {...content.ideasCard} />
          <Social social={content.social} />
        </PageGroup>
        <Footer>
          <FooterNav nav={footerNav} />
        </Footer>
      </Layout>
    </BreakoutModuleNarrow>
  )
}

FeedbackVideoTestimonialPage.propTypes = {
  content: PropTypes.object.isRequired,
}

export default FeedbackVideoTestimonialPage
